import React from 'react'
import ThisDay from '../Component/Days/ThisDay'
import NavBar from '../Component/Nav/NavBar'

const Days = () => {
  return (
    <main>
      <NavBar />
      <ThisDay />
    </main>
  )
}

export default Days
